import { actions, selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { Wacom } from '@sloyd/ui';
import { bridge } from '@sloyd/viewer';
import { useMemo } from 'react';

export type WacomProps = {
  instanceId?: string;
};

const modes = ['taper', 'tilt', 'slant', 'scale'];

const map: any = {
  slant: {
    x: 'modifiers.wack.offsetX',
    y: 'modifiers.wack.offsetY',
  },
  tilt: {
    x: 'modifiers.wack.rotateZ',
    y: 'modifiers.wack.rotateX',
  },
  taper: {
    x: 'modifiers.wack.taperTopX',
    y: 'modifiers.wack.taperTopY',
  },
  scale: {
    x: 'modifiers.wack.scaleX',
    y: 'modifiers.wack.scaleY',
  },
};

export function WacomContainer(props: WacomProps) {
  const { instanceId = 'main' } = props;
  const dispatch = useDispatch();
  const isLoading = useSelector(selectors.base.$showLoaderBar);
  const wacomValue = useSelector(selectors.base.$wacom);
  const currentIds = useSelector(selectors.raw.$rawCurrentIds);
  const { wackModeId } = currentIds;

  const callbacks = useMemo(
    () => ({
      onModeChange: (mode: any) => {
        dispatch(actions.currentIds.patch({ wackModeId: mode }));
      },
      onDrag: (x: number, y: number) => {
        const xKey = map[wackModeId].x;
        const yKey = map[wackModeId].y;

        bridge.patchWackModifiers(instanceId, {
          [xKey]: x,
          [yKey]: y,
        });
      },
      onChange: (x: number, y: number) => {
        const xKey = map[wackModeId].x;
        const yKey = map[wackModeId].y;

        const change = {
          [xKey]: x,
          [yKey]: y,
        };

        bridge.patchWackModifiers(instanceId, change);
        dispatch(actions.valuesModel.patch(change));
      },
      onReset: () => {
        const change = {
          'modifiers.wack.offsetX': 0.5,
          'modifiers.wack.offsetY': 0.5,
          'modifiers.wack.offsetZ': 0.5,
          'modifiers.wack.scaleX': 0.5,
          'modifiers.wack.scaleY': 0.5,
          'modifiers.wack.scaleZ': 0.5,
          'modifiers.wack.rotateX': 0.5,
          'modifiers.wack.rotateY': 0.5,
          'modifiers.wack.rotateZ': 0.5,
          'modifiers.wack.taperTopX': 0.5,
          'modifiers.wack.taperTopY': 0.5,
        };

        bridge.patchWackModifiers(instanceId, change);
        dispatch(actions.valuesModel.patch(change));
      },
    }),
    [wackModeId]
  );

  return (
    <Wacom
      value={wacomValue}
      mode={wackModeId}
      onModeChange={callbacks.onModeChange}
      onDrag={callbacks.onDrag}
      onChange={callbacks.onChange}
      onReset={callbacks.onReset}
    />
  );
}

export default WacomContainer;

/*
       modifiersWack_Influence = 0, // not used
        modifiersWack_OffsetX = 1,  // slant sideways
        modifiersWack_OffsetY = 2,  // slant forward back
        modifiersWack_OffsetZ = 3,  // not used
        modifiersWack_ScaleX = 4,   // not used
        modifiersWack_ScaleY = 5,   // not used
        modifiersWack_ScaleZ = 6,   // not used
        modifiersWack_RotateX = 7,  // not used
        modifiersWack_RotateY = 8,  // twist
        modifiersWack_RotateZ = 9,  // not used
        modifiersWack_TaperTopX = 10, // use
        modifiersWack_TaperTopY = 

*/
